module.exports = __webpack_public_path__ + "img/print_outlined_64.870720be.svg";